const mailVariableOptions = [
  {title: '姓', code: '{{lastname}}'},
  {title: '名', code: '{{firstname}}'},
  {title: '会社', code: '{{company}}'},
  {title: '部署', code: '{{section}}'},
  {title: '役職', code: '{{section_position}}'},
  {title: 'メールアドレス', code: '{{email}}'},
];

export default mailVariableOptions;
